import { useState } from "react";
import { useDispatch } from "react-redux";
import { registerUserAsync } from "../features/auth/authSlice";
import { useNavigate, Link } from "react-router-dom";
import signup from "../assets/img/signup.jpg";


function Register() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [, setErrors] = useState({});
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // validation

  const validate = () => {
      const newErrors = {};

      if (!form.name.trim()) newErrors.name = "Name is required";
      if (!form.email.trim()) {
        newErrors.email = "Email is required";
      } else if (!/\S+@\S+\.\S+/.test(form.email)) {
        newErrors.email = "Invalid email format";
      }

      if (!form.password) {
        newErrors.password = "Password is required";
      } else if (form.password.length < 4) {
        newErrors.password = "Password must be at least 4 characters";
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
  };

  // handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    const resultAction = await dispatch(registerUserAsync(form));
    if (registerUserAsync.fulfilled.match(resultAction)) {
      navigate("/login");
    } else {
      console.log("Error:", resultAction.payload);
    }
  };

  return (
    <>
    <div className="container d-flex align-items-center justify-content-center vh-100">
      <div className="col-md-6">
        <img src={signup} className="signup-img" alt="banner"/>
      </div>
      <div className="col-md-6">
        <div className="outer-form p-4">
            <img src="/logo.png" style={{width:"50px"}} alt="logo"/>
            <h3 className="pt-2">Create an account</h3>
            <p className="text-muted fs-14">Sign up with your valid email and password</p>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <input className="form-control" placeholder="Name" onChange={(e)=>setForm({...form, name:e.target.value})} />
              </div>
              <div className="mb-3">
                <input className="form-control" placeholder="Email" onChange={(e)=>setForm({...form, email:e.target.value})} />
              </div>
              <div className="mb-3">
                <input className="form-control" type="password" placeholder="Password" onChange={(e)=>setForm({...form, password:e.target.value})} />
              </div>
              <button className="btn btn-submit w-100" type="submit">Register</button>
              <p className="mt-3 fs-13 text-muted">Already have an account? <Link to="/login">Login</Link></p>
            </form>
        </div>
      </div>
    </div>
    </>
  );
}

export default Register;